import { makeStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { useActionRunner } from 'src/modules/notification'
import {
  Container,
  ProductList as ProductListComponent,
  Button,
} from 'src/modules/ui'

import { useProducts } from '../hooks'

const useStyles = makeStyles(theme => ({
  addButton: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 0,
      marginRight: theme.spacing(1),
    },
  },
  productTable: {
    backgroundColor: theme.palette.fadedGreen.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    width: '100%',
  },
}))

export const ProductList = ({ products }) => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <Container>
      <ProductListComponent
        toolbarPreFilterComponent={() => (
          <Button
            className={classes.addButton}
            color="primary"
            onClick={() => history.push('/products/add')}
          >
            Add Product
          </Button>
        )}
        products={products}
        showFilter
        showSearch
        tableClassName={classes.productTable}
      />
    </Container>
  )
}

const ProductListContainer = () => {
  const { fetchProducts, products } = useProducts()
  const [doFetchProducts, isFetching] = useActionRunner(fetchProducts, {
    initialFetchingState: true,
  })

  useEffect(() => {
    doFetchProducts()
  }, [])

  if (isFetching) {
    return null
  }

  return <ProductList products={products} />
}

export default ProductListContainer
